// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__ZG1IK","title":"AfterBackImages_title__2dhJM","images":"AfterBackImages_images__1EsEP"};